import { useApi } from "@platform/api";
import { useQuery } from "@tanstack/react-query";

import type { CensusCheckResponse } from "@platform/api/bp-api";

export type CensusUploadCheckState =
  | { readonly kind: "checking" }
  | { readonly kind: "failed" }
  | { readonly kind: "checked"; readonly check: CensusCheckResponse };

/**
 * What bp-api makes of one census file a broker uploaded.
 *
 * The call is a POST because bp-api may read the file and record the check,
 * but it answers from the stored check whenever the RFP's products haven't
 * changed, so asking again on every visit to the step is cheap.
 */
export const useCensusUploadCheck = (
  rfpId: number,
  documentId: number,
): CensusUploadCheckState => {
  const axiosInstance = useApi();

  const query = useQuery({
    queryKey: ["censusUploadCheck", rfpId, documentId],
    queryFn: async () => {
      const response = await axiosInstance.post<CensusCheckResponse>(
        `/bp/v1/rfps/${rfpId}/documents/${documentId}/census-check`,
      );

      return response.data;
    },
  });

  if (query.isError) {
    return { kind: "failed" };
  }

  return query.data
    ? { kind: "checked", check: query.data }
    : { kind: "checking" };
};
